import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["title", "description"];
  static values = { titles: Object, descriptions: Object };

  connect() {
    this.initSliderChangeListener();
    this.initRoleChangeListener();
  }

  disconnect() {
    this.cleanupSliderChangeListener();
    this.cleanupRoleChangeListener();
  }

  // Listens to the user sliding the Webinar Permissions slider, and highlights the corresponding columns in the permissions table
  // according to the current permission level selected
  initSliderChangeListener() {
    this.slider = this.element.querySelector(".range-slider");
    this.inputHandler = this.inputHandler || this.highlightLevel.bind(this);
    this.slider.addEventListener("input", this.inputHandler);
    this.highlightLevel();
  }

  // Listens to the user changing the selected role, and updates the text shown to indicate the scope of webinars
  // that the given role has permissions for
  initRoleChangeListener() {
    this.roleBoxes = document.querySelectorAll("input[name=\"user[role]\"]");
    this.onRoleChange = this.onRoleChange.bind(this);
    this.roleBoxes.forEach((box) => box.addEventListener("change", this.onRoleChange));
  }

  cleanupSliderChangeListener() {
    this.slider.removeEventListener("input", this.inputHandler);
  }

  cleanupRoleChangeListener() {
    this.roleBoxes.forEach((box) => box.removeEventListener("change", this.onRoleChange));
  }

  highlightLevel() {
    const level = parseInt(this.slider.value, 10);

    this.element.querySelectorAll("[data-level]").forEach((el) => {
      el.classList.toggle("active", parseInt(el.dataset.level) <= level);
    });
  }

  onRoleChange(event) {
    if (!event.target.checked) return;
    const role = event.target.value;

    this.updateTitle(role);
    this.updateDescription(role);
  }

  updateTitle(role) {
    if (!this.hasTitleTarget || !this.titlesValue[role]) return;
    this.titleTarget.textContent = this.titlesValue[role];
  }

  updateDescription(role) {
    if (!this.hasDescriptionTarget || !this.descriptionsValue[role]) return;
    this.descriptionTarget.textContent = this.descriptionsValue[role];
  }
}
